import {useId} from 'react'
// eslint-disable-next-line boundaries/dependencies -- grandfathered cross-slice import, predates the slice-boundaries rule
import {Gradient} from 'slices/SideGrid/components'
import {BlobShape} from './BlobShape'

const BLOB_BACKGROUND_HEIGHT = 920

export const AnimatedBlobBackground = () => {
  const leftId = useId().replace(/:/g, '')
  const rightId = useId().replace(/:/g, '')

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 top-0 overflow-hidden"
      style={{height: BLOB_BACKGROUND_HEIGHT}}
    >
      <div className="absolute -left-24 -top-20 w-[600px] motion-safe:animate-blob-float-a">
        <BlobShape uid={`blob-section-left-${leftId}`} />
      </div>
      <div className="absolute -right-32 -top-24 w-[560px] scale-x-[-1] motion-safe:animate-blob-float-b">
        <BlobShape uid={`blob-section-right-${rightId}`} />
      </div>
      <Gradient color="0,36,20" gradientStart={20} height={BLOB_BACKGROUND_HEIGHT} location="bottom" />
    </div>
  )
}
